<template>
    <div class="roothome">

        <div class="wrapper">
            <div style="display: flex; justify-content: center;">

                <!-- ################    Top Menu Bar    ################# -->


                <!-- ################    panorama e busca    ################# -->
                <div class="title4">
                    <div class="dv_title_desk">
                        <span class="tx_title_desk"> {{ titlePage }} </span>
                    </div>

                    <div class="dv_coluna_container">
                        <!-- ################    COLUNA ESQUERDA   ################# -->
                        <div class="dv_coluna_edit_register">

                            <!-- ################    Tipo    ################# -->
                            <div class="di_form_item_s">
                                <span class="tx_form_whiteb" >Tipo</span>
                            </div>
                            <div class="di_form_item_c" onMouseOver="this.style.cursor='pointer'">
                                <div class="di_form_item_c2" v-for="(item, index) in categoria" :key="index" @click="selectSingleItem(categoria, index)">
                                    <div class="di_form_item2_b" v-if="item.selected">
                                        <span class="tx_form_white">{{ item.nome }}</span>
                                    </div>
                                    <div class="di_form_item2" v-if="!item.selected">
                                        <span class="tx_form_gray">{{ item.nome }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- ################    Fotos Estabelecimento   ################# -->
                            <span v-if="tipoAnuncio === 0" class="tx_form_whiteb_sub2" style="font-size: 3vh; color: var(--font-dark-gray2);"> Inserir Foto</span>
                            <span v-if="tipoAnuncio === 0" class="tx_form_whiteb_sub2" style="font-size: 2.2vh"> Adicione uma foto</span>
                            <div v-if="tipoAnuncio === 0" id="photo_contain" style="display: flex; flex-direction: row; background-color: white; overflow-x: scroll; margin-bottom: 3vh">
                                <!--<input style="display: none" ref="inputImage" type="file" @change="onFileSelectedMany" multiple="multiple"/>-->
                                <input style="display: none" ref="inputImage" type="file" accept="image/*" @change="onFileSelectedMany" multiple/>
                                <div class="di_photo0" onMouseOver="this.style.cursor='pointer'" @click="$refs.inputImage.click()">
                                    <img src="/static/imgs/ic_camera.png" alt="profile" class="im_photos0">
                                    <span class="tx_inserir">Inserir foto</span>
                                </div>
                                <!--Animação-->
                                <!--https://codepen.io/dslanger/pen/KqdvMO-->
                                <!--https://stackoverflow.com/questions/26807610/css-only-animate-draw-circle-with-border-radius-and-transparent-background-->
                                <div v-for="(item, index) in photos.slice().reverse()" :key="index" class="di_photo">
                                    <div style="display: flex; position: relative;">
                                        <img v-if="!item.uploaded" src="/static/imgs/circle_insta3.png" alt="profile1" class="im_photos_back">
                                        <img v-else  :src="transpGif" alt="profile2" class="im_photos_back_s">

                                        <img v-if="item.data != null" :src="item.data" alt="profile3" class="im_photos">
                                        <img v-else :src="baseUrlImg + 'MARCADOR/' + getPhotoName(item.file)" alt="profile4" class="im_photos">

                                        <img src="/static/imgs/bt_erase.png" alt="profile" class="im_fechar" @click="removePhoto(photos.length - 1 - index)">
                                    </div>
                                    <div style="display: flex; justify-content: center; align-items: center; margin-top: 1vh;" @click="changeDestaque(index, 'photo_contain')">
                                        <input type="checkbox" :value="index" style="zoom: 1.3; margin-right: 3%; margin-top: 0;" :checked="item.destaque">
                                        <span style="font-size: 1.5vh">Destaque</span>
                                    </div>
                                </div>
                            </div>

                            <!--Formulario dados textuais-->
                            <div v-if="tipoAnuncio === 0 && index <= 2" class="di_form_item" v-for="(item, index) in editing" :key="index">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                        <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                    </div>
                                    <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index !== 1" tabindex="1"/>
                                    <textarea :id="item.id" name="message" style="border: none; width: 100%; border-color: Transparent; overflow: auto; outline: none; font-size: 3.2vh;" rows="4" cols="30" v-model="item.texto" v-if="item.status && index === 1"></textarea>
                                </div>
                            </div>

                            <!--Formulario dados textuais-->
                            <div v-if="index > 2" class="di_form_item" v-for="(item, index) in editing" :key="index">
                                <div class="div_nome">
                                    <div @click="clickInput2_2(index)" onMouseOver="this.style.cursor='pointer'">
                                        <span class="tx_form_grayb" v-if="!item.status">{{ item.campo }}</span>
                                        <span class="tx_form" v-if="item.status">{{ item.campo }}</span>
                                    </div>
                                    <input :id="item.id" class="input_name_m2" type="text" v-model="item.texto" v-if="item.status && index !== 1" tabindex="1"/>
                                </div>
                            </div>

                            <!-- Excluir e Ativar/Desativar-->
                            <div style="display: flex; flex-direction: column; align-items: flex-start;">
                                <div v-if="(new_estab.id > 0) && !ativo" style="display: flex; justify-content: center; align-items: center; cursor: pointer; margin-top: 2vh; margin-bottom: 2vh;" @click="setEstabAtivo()">
                                    <img src="/static/imgs/ic_option_off.png" alt="desativar" class="im_ic_option">
                                    <span style="font-size: 3.5vh; margin-left: 1vh; color: var(--font-dark-gray2); flex-grow: 5;">Item Desativado</span>
                                </div>

                                <div v-if="(new_estab.id > 0) && ativo" style="display: flex; justify-content: center; align-items: center; cursor: pointer; margin-top: 2vh; margin-bottom: 2vh;" @click="setEstabAtivo()">
                                    <img src="/static/imgs/ic_option_on.png" alt="ativar" class="im_ic_option">
                                    <span style="font-size: 3.5vh; margin-left: 1vh; color: var(--font-dark-gray2); flex-grow: 5;">Item Ativo</span>
                                </div>

                                <div v-if="new_estab.id > 0" style="display: flex; justify-content: center; align-items: center; cursor: pointer; margin-bottom: 2vh;" @click="submitformEstab(false)">
                                    <img src="/static/imgs/ic_excluir.png" alt="excluir" style="width: 3.3vh; height: 3vh; object-fit: contain">
                                    <span style="font-size: 3.5vh; margin-left: 1vh; color: var(--font-dark-gray2)">Excluir Anúncio</span>
                                </div>
                            </div>
                        </div>

                        <!-- ################    COLUNA DIREITA   ################# -->
                        <div class="dv_coluna_edit_register">

                            <!-- ################    Estabelecimentos    ################# -->
                            <div class="di_form_item_s">
                                <span class="tx_form_whiteb" >Estabelecimentos</span>
                            </div>

                            <div class="di_form_item_s">
                                <span style="text-align: left">Buscar estabelecimentos que exibirão o anúncio:</span>
                            </div>
                            <div class="di_form_item_s">
                                <input type="text" class="search" style="width: 100%;" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"  v-on:keyup="getEstabsSearch()" v-model="search_text" :placeholder="getInterText(inter_ind.pesquisar) + '...'">
                            </div>
                            <div v-for="estab in estabs_search" style="display: flex; width: 100%; justify-content: flex-start; margin-bottom: 0.5vh">
                                <img v-if="estab.tbFotos.length > 0" :src="baseUrlImg + 'MARCADOR/' + getPhotoName(estab.tbFotos[0].file)" style="width: 8vh; height: 5vh; margin-right: 2%"/>
                                <span v-html="decodeChars(estab.nome)"></span>
                                <span @click="adicionaEstab(estab)" style="margin-left: 2%; cursor: pointer"> - Adicionar</span>
                            </div>

                            <div class="di_form_item_s">
                                <span style="text-align: left">Estabelecimentos que exibirão o anúncio:</span>
                            </div>

                            <div v-for="(estab, index) in estabsAnuncio" style="display: flex; width: 100%; justify-content: flex-start; margin-bottom: 0.5vh">
                                <img v-if="estab.tbFotos.length > 0" :src="baseUrlImg + 'MARCADOR/' + getPhotoName(estab.tbFotos[0].file)" style="width: 8vh; height: 5vh; margin-right: 2%"/>
                                <span v-html="decodeChars(estab.nome)"></span>
                                <span @click="removeEstab(index)" style="margin-left: 2%; cursor: pointer"> - Remover</span>
                            </div>



                        </div>

                    </div>

                    <!-- ################    Form    ################# -->
                    <div style="display: flex; flex-direction: column; margin-top: 2%;">
                    </div>

                    <span v-for="(item, index) in msg_erros" class="error_msg" :key="index" style="margin-left: 20px;"> * {{ item }} <br/> </span>

                    <!-- ################    Botao Enviar    ################# -->
                    <div style="width: 100%; margin-top: 2vh; margin-bottom: 5vh; display: flex; flex-direction: row; justify-content: center; align-items: center;">
                        <div style="padding: 1vh; padding-right: 5vh; padding-left: 5vh; background-color: var(--bg-purple); text-align: center; border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="submitformEstab(true)">
                            <span style="color: white; font-size: 25pt;">{{ getInterText(inter_ind.enviar) }}</span>
                        </div>
                    </div>

                </div>
            </div>

            <!--Barra de rodapé -->
        </div>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_cinza" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 0 0.33
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_blue" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.058
                 0 0 0 0 0.384
                 0 0 0 0 0.674
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_white" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 0 1
                 0 0 0 1 0"/>
        </filter>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <div class="overlay" @click="changeSideBar()"></div>

    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'
    import $ from 'jquery'
    import axios from 'axios'

    export default {
        mixins: [advMixin],
        name: 'RegisterAnuncio',
        data () {
            return {
                name: 'RegisterAnuncio',
                ativo: true,
                tipoAnuncio: 0,
                estabs: [],
                cats: [],
                productsFull: [],
                estabs_full: [],
                estabs_search: [],
                estabsAnuncio: [],
                quantCatsSelected: 0,
                idCat: 0,
                search_text: '',
                showingSearch: false,
                showCats_d: true,
                cepOk: true,
                showAddress: false,
                response: {
                    status: 'ok'
                },
                titlePage: 'Cadastrar Anúncio',
                tituloCat: 'Destaques',
                corCat: '#96989b',
                panoInd: 0,
                new_estab: {},
                photos: [

                ],
                qMaxFotos: 1,
                valid: {
                    nome: true,
                    descricao: true,
                    categorias: true,
                    rua: true,
                    bairro: true,
                    cidade: true,
                    estado: true,
                    horario: true,
                    email: true,
                    tel: true,
                    pass1: true,
                    pass2: true,
                    captcha: false,
                    enterAuto: false,
                    termos: false,
                    errorSubmit: false
                },
                editing: [
                    {
                        id: 'zeroID',
                        campo: 'Título',
                        texto: '',
                        status: false
                    },
                    {
                        id: 'umID',
                        campo: 'Descrição',
                        texto: '',
                        status: false
                    },
                    {
                        id: 'doisID',
                        campo: 'Telefone',
                        texto: '',
                        status: false
                    },
                    {
                        id: 'tresID',
                        campo: 'Link',
                        texto: '',
                        status: false
                    },
                    {
                        id: 'quatroID',
                        campo: 'Preço',
                        texto: '',
                        status: false
                    }
                ],
                categoria: [
                    {
                        id: 0,
                        nome: 'Anúncio Externo',
                        selected: false,
                        imPath: ''
                    },
                    {
                        id: 1,
                        nome: 'Anúncio Advice',
                        selected: false,
                        imPath: ''
                    }
                ],
                msg_erros: [

                ],
                transpGif: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
            }
        },
        methods: {
            adicionaEstab (estab) {
                this.estabsAnuncio.push(estab);
            },
            removeEstab (index) {
                this.estabsAnuncio.splice(index, 1);
            },
            getEstabsSearch() {
                console.log('getEstabsSearch ' + this.search_text);

                this.estabs_search = [];

                if (this.search_text.length<3) {
                    console.log('getEstabsSearch::nao vou buscar');
                    return ;
                }

                var search_text2 = this.search_text.toLowerCase();
                var i;
                console.log('this.estabs_full.length: ', this.estabs_full.length)
                for (i=0 ; i < this.estabs_full.length ; i++) {
                    var estab = this.estabs_full[i];

                    if (estab.ativo && estab.aprovado) {
                        if (estab.nome.toLowerCase().indexOf(search_text2) >= 0) {
                            this.estabs_search.push(estab);
                            console.log('search: ', estab);
                        }
                    }
                }
            },
            getPhotoName (path) {
                if (!path.includes('.jpg')) {
                    return path + '.jpg'
                } else {
                    return path
                }
            },
            setEstabAtivo () {
                this.ativo = !this.ativo
            },
            goToHome () {
                this.goToBack()
            },
            adjustCaracterEncoding () {
                var i
                var vm = this
                for (i = 0; i < vm.productsFull.length; i++) {
                    try {
                        vm.productsFull[i].nome = decodeURIComponent(escape(vm.productsFull[i].nome))
                    } catch (e) {
                        vm.productsFull[i].nome = unescape(vm.productsFull[i].nome)
                    }
                    try {
                        vm.productsFull[i].horario = decodeURIComponent(escape(vm.productsFull[i].horario))
                    } catch (e) {
                        vm.productsFull[i].horario = unescape(vm.productsFull[i].horario)
                    }
                    try {
                        vm.productsFull[i].responsavel = decodeURIComponent(escape(vm.productsFull[i].responsavel))
                    } catch (e) {
                        vm.productsFull[i].responsavel = unescape(vm.productsFull[i].responsavel)
                    }
                    try {
                        vm.productsFull[i].rua_num = decodeURIComponent(escape(vm.productsFull[i].rua_num))
                    } catch (e) {
                        vm.productsFull[i].rua_num = unescape(vm.productsFull[i].rua_num)
                    }
                    try {
                        vm.productsFull[i].bairro = decodeURIComponent(escape(vm.productsFull[i].bairro))
                    } catch (e) {
                        vm.productsFull[i].bairro = unescape(vm.productsFull[i].bairro)
                    }
                    try {
                        vm.productsFull[i].cidade = decodeURIComponent(escape(vm.productsFull[i].cidade))
                    } catch (e) {
                        vm.productsFull[i].cidade = unescape(vm.productsFull[i].cidade)
                    }
                }
            },
            clickInput2_2 (i) {
                var j = 0
                this.editing[i].status = !this.editing[i].status
                if (this.editing[i].status === true) {
                    this.showCats = false
                    for (j = 0; j < this.editing.length; j++) {
                        if (j !== i) {
                            // console.log('this.editing[j].texto.length ' + this.editing[j].texto.length)
                            if (this.editing[j].texto.length === 0) {
                                this.editing[j].status = false
                                // console.log('setando para false ' + j)
                            }
                        }
                    }
                }

                if (this.editing[i].status === true) {
                    var idfocus = this.getId(i)

                    this.$nextTick(function () {
                        $(idfocus).focus()
                    })
                }
            },
            atualizaParametros () {
                console.log('atualizaParametros')
                console.log(this.$route.query)

                if (this.$route.query.idCat === null) {
                    this.idCat = 0
                    console.log('id eh nulo')
                } else {
                    this.idCat = this.$route.query.idCat
                    console.log('id eh valido ' + this.idCat)
                }

                this.atualizaEstabs(this.idCat)
            },
            selectCat (index) {
                console.log('selecCat index ' + index)
                if (this.grupos[index].deleted === false) {
                    if (this.quantCatsSelected < 3) {
                        this.grupos[index].deleted = true
                        this.quantCatsSelected++
                    }
                } else {
                    this.quantCatsSelected--
                    this.grupos[index].deleted = false
                }
            },
            selectSingleItem (lista, index) {
                console.log('selectSingleItem index ' + index)
                this.tipoAnuncio = index;
                let i
                for (i = 0; i < lista.length; i++) {
                    lista[i].selected = false
                }

                lista[index].selected = true
            },
            selectItem (lista, index) {
                console.log('selectItem index ' + index)
                let status = !lista[index].selected
                lista[index].selected = status
            },
            async onFileSelectedMany (chooseEvent) {
                console.log('chooseEvent: ', chooseEvent)

                this.msg_erros = []

                this.imgType = 2 // XGA = 2;

                // console.log('fotos: ', this.photos.length, chooseEvent.target.files.length, this.qMaxFotos)
                if (this.photos.length + chooseEvent.target.files.length > this.qMaxFotos) {
                    alert('Quantidade máxima do fotos atingida, adicione no máximo ' + this.qMaxFotos)
                    return
                }
                var beginIndex = this.photos.length

                var i
                var tries
                for (i = 0; i < chooseEvent.target.files.length; i++) {
                    console.log(i + '::uploading photo: ', chooseEvent.target.files[i].name)
                    this.preparingPhoto = true
                    tries = 0
                    this.readImage(chooseEvent.target.files[i], beginIndex + i)
                    while (this.preparingPhoto) {
                        // console.log('preparingPhoto1: ', this.preparingPhoto);
                        await this.sleep(1000)
                        if (tries++ > 5) {
                            break
                        }
                    }
                }
            },
            readImage (fileImage, pIndex) {
                var reader = new FileReader()
                var vm = this
                var photo = {}
                photo.name = fileImage.name

                console.log('photo:step1: ', photo)

                // Funcao de teste.
                reader.onload = function (readerEvent) {
                    console.log('onload:readerEvent ', readerEvent)
                }

                // PASSO 2
                reader.onloadend = function (readerEvent) {
                    console.log('onloadend:readerEvent ', readerEvent)

                    var image = new Image()

                    // PASSO 4
                    image.onload = function (imageEvent) {
                        photo.data = readerEvent.target.result
                        photo.index = pIndex
                        // console.log('step2:photo: ', photo);
                        // console.log('step2:image: ', image);
                        // console.log('step2:imageEvent: ', imageEvent);
                        // console.log('step2:target: ',   imageEvent.target);
                        // console.log('step2:exifdata: ', imageEvent.target.exifdata);

                        var resized = vm.resizePhoto(photo, image, vm.imgMaxWidth, vm.imgMaxHeight)

                        // se nao precisou redimensioanr entao envia a imagem normal.
                        if (!resized) {
                            photo.blob = fileImage
                            vm.prepareUpload(photo)
                        }

                        vm.preparingPhoto = false
                    }

                    // PASSO 3
                    image.src = readerEvent.target.result
                    vm.profileSrc = readerEvent.target.result
                }

                // PASSO 1
                reader.readAsDataURL(fileImage)
            },
            resizePhoto (photo, img, maxWidth, maxHeight, pIndex) {
                var width = img.width
                var height = img.height
                var isTooLarge = false

                console.log('resizePhoto::img.width: ' + img.width)
                console.log('resizePhoto::img.height: ' + img.height)
                console.log('resizePhoto::maxWidth: ' + maxWidth)
                console.log('resizePhoto::maxHeight: ' + maxHeight)
                console.log('img:: ', img)

                // LANDSCAPE
                if (width >= height && width > maxWidth) {
                    // width is the largest dimension, and it's too big.
                    height *= maxWidth / width
                    width = maxWidth
                    isTooLarge = true
                } else if (height > maxHeight) {
                    // PORTRAIT
                    // either width wasn't over-size or height is the largest dimension
                    // and the height is over-size
                    width *= maxHeight / height
                    height = maxHeight
                    isTooLarge = true
                }

                // O novo arquivo redimensionado vai ser jpg.
                console.log('1::photo.name: ', photo.name)
                photo.name = this.removeExtension(photo.name) // + '.jpg'
                console.log('2::photo.name: ', photo.name)

                console.log('resizePhoto::img.width:Novo: ' + width)
                console.log('resizePhoto::img.heightNovo: ' + height)

                // nao precisa redimensionar
                if (!isTooLarge) {
                    console.log('isTooLarge:: Não precisa redimensionar. ' + isTooLarge)
                    return false
                }

                var canvas = document.createElement('canvas')
                var ctx = canvas.getContext('2d')
                canvas.width = width
                canvas.height = height
                var vm = this

                // draw image
                ctx.drawImage(img, 0, 0, width, height)

                // Assim nao funciona, tava dando erro no base64 gerado que nao era do tipo url.
                // var dataUrl = canvas.toDataURL('image/jpeg', 0.8);
                // var resizedImage = this.dataURLToBlob(dataUrl);
                canvas.toBlob(function (blob) {
                    console.log('resized blob: ', blob)
                    photo.blob = blob

                    vm.prepareUpload(photo)
                }, 'image/jpeg', 0.8)

                // imagem foi redimensionada
                return true
            },
            removeExtension (name) {
                console.log('removeExtension::vou remover extensao de: ', name)
                var pointPos = name.lastIndexOf('.')

                console.log('removeExtension::pointPos ', pointPos)
                if (pointPos > 1) {
                    console.log('removeExtension::sub ', name.substr(0, pointPos))
                    return name.substr(0, pointPos)
                } else {
                    return name
                }
            },
            prepareUpload (photo, pIndex) {
                var vm = this

                if (photo.blob.name === undefined) {
                    photo.blob.name = photo.name
                }

                console.log('photo.blob.name: ', photo.blob.name)

                console.log('Old: data: ', photo.data)
                console.log('New: blob: ', photo.blob)
                photo.file = ''
                photo.uploaded = false
                photo.loading = false
                photo.id = -1
                if (pIndex !== undefined) {
                    photo.index = pIndex
                }
                photo.destaque = false

                vm.photos.push(photo)
                // vm.picsIndex++; // index of the last photo

                console.log('vou fazer o upload')
                vm.uploadPhoto(photo)
            },
            uploadPhoto (photo) {
                console.log('fazendo o upload ')
                // var myUrl = this.baseUrlApi;
                var myUrl = this.baseUrlApi + 'uploadVGA'
                console.log('Uploading URL: ', myUrl)
                var vm = this
                const fd = new FormData()

                if (photo == null) {
                    alert('Selecione uma imagem')
                    return
                }

                let r = Math.random().toString(36).substr(2, 10)

                photo.file = r
                photo.loading = true

                console.log('random: ' + r)
                console.log('Uploading file: ', photo.blob)
                console.log('name: ' + photo.blob.name)
                console.log('photo.index: ' + photo.index)
                console.log('photos.length: ' + vm.photos.length)
                if (vm.photos.length > photo.index) {
                    console.log('photos[' + photo.index + '].index: ' + vm.photos[photo.index].index)
                }
                console.log('photos: ', vm.photos)
                if (vm.photos.length > photo.index) {
                    console.log('iguais: photos[' + photo.index + ']: ', vm.photos[photo.index])
                }
                console.log('iguais: photo      : ', photo)

                fd.append('file', photo.blob, photo.name)
                fd.append('randFile', r)
                fd.append('imgType', '' + this.imgType) // 2 means image Marcador, medium size.
                // VGA = 1;
                // XGA = 2;

                axios.post(myUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: uploadEvent => {
                        console.log('Upload progress: ' + Math.round(uploadEvent.loaded * 100.0 / uploadEvent.total) + '%')
                    }
                })
                    .then(res => {
                        console.log('resposta server: ', res)
                        photo.loading = false
                        photo.uploaded = true

                        if (res.status === 200) {
                            console.log('Uploading sucess ' + photo.index)
                        } else {
                            alert('Não foi possível fazer o upload, tente novamente, cod: ' + res.status)
                            console.log('Error ao inserir ' + photo.index)
                            vm.removePhoto(photo.index)
                        }
                    }).catch(function (err) {
                        photo.loading = false
                        console.log('Uploading error: ' + err)
                        alert('Não foi possível fazer o upload, tente novamente.')
                        console.log('Error ao inserir ' + photo.index)
                        vm.removePhoto(photo.index)
                    })
            },
            removePhoto (index) {
                this.photos.splice(index, 1)
                // this.picsIndex--;

                var i
                for (i = index; i < this.photos.length; i++) {
                    this.photos[i].index--
                }
            },
            // busca o estab na lista de estabs e faz o update dele com os novos valores
            atualizaEstabUpdated (estab, add) {
                console.log('atualizaEstabUpdated: ', estab)
                for (let i = 0; i < this.anuncios.length; i++) {
                    if (this.anuncios[i].id === estab.id) {
                        // se tiver removendo.
                        if (add !== undefined && !add) {
                            console.log('removendo realmente da lista o index ', i)
                            this.anuncios.splice(i, 1)
                            return
                        }

                        console.log('alterando: ' + this.anuncios[i].nome + ' para: ' + estab.nome)

                        this.anuncios[i].ativo = estab.ativo
                        this.anuncios[i].deleted = estab.deleted
                        this.anuncios[i].titulo = estab.titulo
                        this.anuncios[i].descricao = estab.descricao
                        this.anuncios[i].telefone = estab.telefone
                        this.anuncios[i].link = estab.link
                        this.anuncios[i].valor = estab.valor
                        this.anuncios[i].tipo = estab.tipo
                        this.anuncios[i].photos = estab.photos
                        this.anuncios[i].ownerid = estab.ownerid
                        this.anuncios[i].estabs = estab.estabs
                        this.anuncios[i].photos = estab.photos

                        this.product = this.anuncios[i]

                        break
                    }
                }
            },
            submitformEstab (add) {
                this.msg_erros = []

                if (!add) {
                    if (!confirm('Deseja remover o anúncio?')) {
                        return
                    }
                }

                if (!this.user.sucess) {
                    let msg = 'Usuario nao identificado, faça o login.'
                    // alert(msg)
                    this.msg_erros.push(msg)
                }

                var i
                for (i = 0; i < this.photos.length; i++) {
                    if (!this.photos[i].uploaded) {
                        let msg = 'Aguarde o término do envio das fotos.'
                        console.log(msg)
                        // alert(msg);
                        this.msg_erros.push(msg)
                        break
                    }
                }

                if (this.editing[0].texto.length < 2 && this.tipoAnuncio == 0) {
                    let msg = 'Informe o título'
                    console.log(msg)
                    // alert(msg)
                    this.msg_erros.push(msg)
                }

                // if (this.editing[1].texto.length < 2) {
                //     let msg = 'Informe a descrição'
                //     console.log(msg)
                //     // alert(msg)
                //     this.msg_erros.push(msg)
                // }

                if (this.editing[3].texto.length < 2) {
                    let msg = 'Informe o link'
                    console.log(msg)
                    // alert(msg)
                    this.msg_erros.push(msg)
                }

                if (this.photos.length === 0 && this.tipoAnuncio == 0) {
                    let msg = 'Insira pelo menos uma foto'
                    console.log(msg)
                    // alert(msg);
                    this.msg_erros.push(msg)
                }

                var vm = this

                this.new_estab = this.generateEstab()

                // Ajusta as virgulas do preco
                console.log('Preco antes: ', this.new_estab.valor)
                this.new_estab.valor = this.new_estab.valor.toString().replace('.', '')

                let p1 = this.new_estab.valor.indexOf(',')
                let p2 = this.new_estab.valor.lastIndexOf(',')
                if (p1 !== p2) {
                    let msg = 'Há uma vírgula a mais no preço.'
                    console.log(msg)
                    this.msg_erros.push(msg)
                }

                console.log('Preco depois: ', this.new_estab.valor)

                if (this.msg_erros.length > 0) {
                    return
                }

                // colocar no formato com o operador . separando as casas decimais. Para enviar ao servidor.
                this.new_estab.valor = this.new_estab.valor.replace(',', '.')
                console.log('Preco depois2: ', this.new_estab.valor)

                console.log('new estab: ', this.new_estab)

                console.log('user mail: ' + this.user.email)

                this.loading.form = true
                // this.valid.errorSubmit = false;

                var url = ''
                if (add) {
                    url = this.baseUrlApi + 'newAnun'
                } else {
                    url = this.baseUrlApi + 'rmAnun'
                }
                console.log('Enviando post com o user')
                console.log(url)

                axios.post(url, this.new_estab)
                    .then(function (response) {
                        vm.loading.form = false
                        console.log('Response.data ', response.data)
                        console.log('Response.status ' + response.status)

                        // colocar no formato com o operador , separando as casas decimais. Para exibir no site.
                        // vm.new_estab.pre1 = vm.new_estab.pre1.replace('.', ',')
                        // vm.new_estab.pre2 = vm.new_estab.pre2.replace('.', ',')

                        if (response.status === 200) {
                            console.log('Status::200::Tudo certo')
                            vm.currentTab = 1
                            console.log('submitformEstab::currentTab: ', vm.currentTab)
                            console.log('submitformEstab::currentTab: ', vm.currentTab)
                            console.log('submitformEstab::currentTab: ', vm.currentTab)
                            if (vm.new_estab.id > 0) {
                                if (add) {
                                    alert('Anúncio Atualizado com Sucesso!')
                                } else {
                                    alert('Anúncio removido com Sucesso!')
                                }

                                vm.atualizaEstabUpdated(vm.new_estab, add)
                            } else {
                                console.log('Cadastrado realizado com Sucesso!')
                                alert('Cadastrado realizado com Sucesso!')
                                var info = {
                                    idEstabelecimento: response.data.id,
                                    favType: 1, // 1 == OWNER
                                    avaliacao: 0,
                                    owner: true
                                }
                                console.log('submitformEstab::Info: ', info)
                                console.log('vm.user.estabelecimentos ', vm.user.estabelecimentos)

                                if (vm.user.estabelecimentos == null) {
                                    vm.user.estabelecimentos = []
                                }

                                vm.user.estabelecimentos.push(info)
                                console.log('submitformEstab::vm.productsFull: ', vm.productsFull)
                                console.log('submitformEstab::vm.new_estab: ', vm.new_estab)
                                vm.new_estab.id = response.data.id
                                vm.new_estab.photos = vm.new_estab.photos
                                // for (let j = 0; j < vm.new_estab.pics.length; j++) {
                                //     console.log('3::estab.pics[j].file: ', vm.new_estab.pics[j].file)
                                //     if (!vm.new_estab.pics[j].file.includes('.jpg')) {
                                //         vm.new_estab.pics[j].file = vm.new_estab.pics[j].file + '.jpg'
                                //     }
                                //     console.log('4::estab.pics[j].file: ', vm.new_estab.pics[j].file)
                                // }
                                vm.productsFull.push(vm.new_estab)
                                console.log('submitformEstab::push realizado')

                                localStorage.setItem('user', JSON.stringify(vm.user))
                            }

                            vm.$nextTick(function () {
                                vm.sleep(1000).then(() => {
                                    // console.log('window.history.length ', window.history.length);
                                    // if (window.history.length > 2) {
                                    //     // console.log('vm.$router.back()')
                                    //     // vm.$router.push({params: { productsFull: vm.productsFull, product: vm.product }})
                                    //     // vm.$router.back()
                                    // } else {
                                    //     console.log('goto Home')
                                    //     vm.goToPagina('Home')
                                    // }
                                    console.log('goto Home')
                                    vm.goToPagina('go')
                                })
                            })
                        } else if (response.status === 208) {
                            console.log('Status::208::Usuario não existente')
                            alert('Usuario não existente')
                        } else {
                            alert(response.status + ' Erro ao realizar a ação. Por favor tente novamente. status: ' + response.status)
                        }
                    })
                    .catch(function (error) {
                        vm.loading.form = false
                        alert('Erro ao realizar a ação. Por favor tente novamente.')
                        console.log('ERROR::' + error)

                        // colocar no formato com o operador , separando as casas decimais. Para exibir no site.
                        // vm.new_estab.pre1 = vm.new_estab.pre1.replace('.', ',')
                        // vm.new_estab.pre2 = vm.new_estab.pre2.replace('.', ',')
                    })

                console.log('Enviado post :: FIM')
            },
            decodeChars (encodedStr) {
                var decoded = $('<div/>').html(encodedStr).text()
                return decoded
            },
            fillFieldsEstab (estab) {
                if (estab.titulo != null) {
                    this.editing[0].texto = this.decodeChars(this.decodeChars(estab.titulo))
                }
                if (estab.descricao != null) {
                    this.editing[1].texto = this.decodeChars(this.decodeChars(estab.descricao))
                }
                if (estab.telefone != null) {
                    this.editing[2].texto = this.decodeChars(this.decodeChars(estab.telefone))
                }
                if (estab.link != null) {
                    this.editing[3].texto = this.decodeChars(this.decodeChars(estab.link))
                }
                if (estab.valor != null) {
                    estab.valor = estab.valor.toString().replace('.', ',')
                    this.editing[4].texto = estab.valor + ''
                }

                this.ativo = estab.ativo

                for (let i = 0; i < this.editing.length; i++) {
                    console.log('analisando status de:', i, this.editing[i].campo)
                    if (this.editing[i].texto.length > 0) {
                        console.log('setando status de:', i, this.editing[i].campo)
                        this.editing[i].status = true
                    }
                }
                console.log('preenchi os fields')

                this.setEstabsIDs(estab)
                this.setPhotosNames(estab)
                this.setTipo(estab)
            },
            setPhotosNames (estab) {
                this.photos = []
                console.log('estab: ', estab)
                for (let j = 0; j < estab.photos.length; j++) {
                    var photo = {
                        data: null,
                        file: estab.photos[j].file,
                        loading: false,
                        uploaded: true,
                        id: estab.photos[j].id,
                        destaque: false
                    }
                    this.photos.push(photo)
                }
                // this.picsIndex = estab.photos.length;
            },
            getTipo () {
                for (let i = 0; i < this.categoria.length; i++) {
                    if (this.categoria[i].selected) {
                        console.log('getTipo() retornando: ' + i)
                        this.tipoAnuncio = i;
                        return i;
                    }
                }

                console.log('getTipo() retornando por fora: 0')
                return 0;
            },
            setTipo (estab) {
                for (let i = 0; i < this.categoria.length; i++) {
                    this.categoria[i].selected = false;
                }

                console.log('setando tipo para: ', estab.tipo)
                this.categoria[estab.tipo].selected = true;

                this.tipoAnuncio = estab.tipo;
            },
            setEstabsIDs (prod) {
                // console.log('setEstabsIDs', prod)
                // console.log('this.estabs_full.length', this.estabs_full.length)
                // console.log('this.estabs_full', this.estabs_full)
                // console.log('prod.estabs.length', prod.estabs.length)
                for (let j = 0; j < this.estabs_full.length; j++) {
                    for (let i = 0; i < prod.estabs.length; i++) {
                        // console.log('comparing: ', this.estabs_full[j].id, prod.estabs[i])
                        if (this.estabs_full[j].id === prod.estabs[i]) {
                            // console.log('adding: ', this.estabs_full[j])
                            this.estabsAnuncio.push(this.estabs_full[j]);
                        }
                    }
                }
            },
            generateEstab () {
                var prod = {}
                prod.titulo = this.editing[0].texto
                prod.descricao = this.editing[1].texto
                prod.telefone = this.editing[2].texto
                prod.link = this.editing[3].texto
                prod.valor = this.editing[4].texto
                if (prod.valor.length === 0) {
                    prod.valor = 0
                }
                prod.estabs = this.getIDs(this.estabsAnuncio)
                prod.photos = this.getPhotosNames()

                prod.uMail = this.user.email
                prod.uToken = this.user.pass

                prod.tipo = this.getTipo();
                prod.id = this.new_estab.id
                prod.ativo = this.ativo
                prod.deleted = false
                prod.localid = 1
                prod.ownerid = this.user.id

                return prod
            },
            getIDs (lista) {
                var vec = []
                for (let j = 0; j < lista.length; j++) {
                    vec.push(lista[j].id)
                }

                return vec
            },
            getPhotosNames () {
                var vec = []
                var j = 0
                for (j = 0; j < this.photos.length; j++) {
                    if (this.photos[j].uploaded === true) {
                        console.log(this.photos[j].id + '::adicioando foto: ' + this.photos[j].file)
                        // Esse photo nao eh para ter o data, o loading, nem o uploaded. Pois tem que ser igual ao advice.model.Foto
                        var photo = {
                            id: this.photos[j].id,
                            file: this.photos[j].file,
                            ordem: j
                        }
                        vec.push(photo)
                    }
                }
                return vec
            },
            changeDestaque (index, scroolElementName) {
                var vm = this
                // console.log('changeDestaque1: ' + index)
                index = this.photos.length - index - 1
                // console.log('changeDestaque2: ' + index)

                for (let i = 0; i < this.photos.length; i++) {
                    this.photos[i].destaque = false
                }

                this.photos[index].destaque = !this.photos[index].destaque

                this.sleep(500).then(() => {
                    vm.array_move_first(vm.photos, index)
                    if (scroolElementName !== undefined) {
                        let el = document.getElementById(scroolElementName)
                        $('#' + scroolElementName).animate({
                            scrollLeft: el.scrollWidth
                        }, 1000)
                    }
                })
            },
            checkName (name) {
                this.valid.nome = name.length >= 3
                return this.valid.nome
            },
            checkEmail (email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                this.valid.email = re.test(String(email).toLowerCase())
                return this.valid.email
            },
            checkTelefone (tel) {
                var teltrim = tel.replace(/\D/g, '')
                // console.log("Check telefone " + tel.length + '  ' + tel);
                // console.log("Check telefonetrim " + teltrim.length + '  ' + teltrim);
                // 12345678901
                // 83988031862
                this.valid.tel = teltrim.length >= 10 && teltrim.length <= 11
                return this.valid.tel
            },
            checkPass (pass) {
                return pass.length >= 8
            },
            checkPass2 (pass) {
                this.valid.pass2 = this.editing[3].texto === pass

                return this.valid.pass2
            },
            checkPassEquals (pass1, pass2) {
                return pass1 === pass2
            }
        },
        created () {
            console.log(this.nome + '::created!!')

            console.log(this.nome + '::Terminei o created!!')
        },
        beforeMount () {
            console.log(this.nome + '::beforeMount!!')

            console.log(this.nome + '::Terminei o beforeMount!!')
        },
        mounted () {
            console.log(this.nome + '::mounted!!')

            this.new_estab.id = -1

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
            }

            if (this.$route.params.anuncios) {
                console.log('Usando anuncios passados por parametro!!');
                this.anuncios = this.$route.params.anuncios;
            }
            else {
                console.log('Baixando estabs!!');
                this.getAnuncios();
            }

            console.log('estabs_full: ', this.estabs_full)

            if (this.$route.params.product) {
                console.log('Vou editar!!')

                this.new_estab = this.$route.params.product
                this.product = this.$route.params.product
                this.fillFieldsEstab(this.new_estab)
                this.titlePage = 'Editar Anúncio'
            }

            if (this.$route.params.productsFull) {
                console.log(this.name + '::Recebi productsFull.')

                this.productsFull = this.$route.params.productsFull
            }

            if (localStorage.getItem('user')) {
                // this.user = localStorage.getItem('user');
                this.user = JSON.parse(localStorage.getItem('user'))
                try {
                    this.user.nome = decodeURIComponent(escape(this.user.nome))
                } catch (e) {
                    this.user.nome = unescape(this.user.nome)
                }
            }

            console.log(this.nome + '::Terminei o mounted!!')
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        /*background-color: #f0f0f0;*/
        background-color: var(--main-bg-color);
        overflow-y: scroll;
    }
    .roothome::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }

    .title4 {
        /*height: 275px;*/
        /*max-height: 275px;*/
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: var(--height-top-bar);
        background-color: white;
    }

    div_botao_t {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 5vh;
    }

    select#sel_cats {
        margin-left: 2vw;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;       /* Remove default arrow */
        outline: none;
        background-color: var(--bg-blue-grad1);
        /*background-color: red;*/
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: none;
        padding-left: 2%;
        /*font-size: 12pt;*/
        font-size: 2vh;
    }

    .error_msg {
        font-family: 'Humanst521BT';
        color: red;
        font-size: 2.5vh;
    }

    .im_ic_option {
        width: 4.4vh;
        height: 3vh;
        object-fit: fill;
        /*background-color: #0f62ac;*/
        border-radius: 20px;
        border-style: solid;
        border-color: darkgray;
        border-width: 1px;
    }

    @media screen and (max-width: 999px) {
        .title4 {
            width: 100%;
        }
    }
    @media screen and (min-width: 1000px) {
        .title4 {
            width: 90%;
        }
    }
    @media screen and (min-width: 1400px) {
        .title4 {
            width: 80%;
        }
    }
    @media screen and (min-width: 1600px) {
        .title4 {
            width: 70%;
        }
    }
    @media screen and (min-width: 1900px) {
        .title4 {
            width: 65%;
        }
    }
    @media screen and (min-width: 2200px) {
        .title4 {
            width: 50%;
        }
    }

    .im_cat_min2, .im_cat_min2_gray {
        width: 17px;
        height: 17px;
        margin-right: 10px;
        object-fit: contain;
    }
    .im_cat_min2, .im_cat_min2_gray {
        /*width: 40px;*/
        /*height: 40px;*/
        width: 2.8vw;
        height: 2.8vw;
    }

    .im_cat_min2_gray {
        filter: url(#colorize_blue);
        /*background-color: red;*/
    }

    .di_photo0 {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 5px;
        min-width: 90px;
        width: 90px;
        height: 90px;
        background: #EEE;
        margin-left: 10px;
        border-radius: 50%;
        padding: 10px;
        padding-top: 20px;
    }

    .im_photos, .im_photos_back {
        display: flex;
        height: 60%;
    }

    .im_photos, .im_photos0, .im_photos_back, .im_photos_back_s {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        object-fit: cover;
    }

    .im_photos, .im_photos_back, .im_photos_back_s {
        width: 86px;
        height: 86px;
        background-color: white;
        position: relative;

    }

    .im_photos0 {
        /*background: green;*/
        object-fit: contain;
        border-radius: 0;
        padding: 0px;
        width: 70%;
        height: 61%;
    }

    .di_photo, .di_photo_traje, .di_photo_ticket {
        display: inline-block;
        /*background-color: red;*/
        position: relative;
        height: 100%;
        margin: 5px;
    }
    .di_photo {
        /*background-color: var(--bg-blue);*/
        background-size: contain;
        border-radius: 50%;
        padding: 4px;
        position: relative;
    }

    .di_photo_ticket {
        width: 11%;
        max-width:11%;
        margin: 0;
        /*background-color: rebeccapurple;*/
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .di_circle, .di_circle_s {
        width: 80%;
        /*height: 3vh;*/
        padding-bottom: 80%;
        background: white;
        border-radius: 50%;
        /*background-color: rebeccapurple;*/
        box-shadow: -1px 1px 2px var(--font-dark-gray);
    }
    .di_circle_s {
        background-color: var(--bg-blue);
    }

    .im_photos_back_s {
        background-color: var(--bg-blue);
    }

    .im_photos {
        /*background-color: red;*/
        margin: 6px;
        margin-left: -80px;
        width: 74px;
        height: 74px;
    }

    .im_photos_back {
        -webkit-animation: rotate 3s infinite linear;
        -moz-animation: rotate 3s infinite linear;
        animation: rotate 3s infinite linear;
    }

    @-moz-keyframes rotate { 100% { -moz-transform: rotate(360deg); } }
    @-webkit-keyframes rotate { 100% { -webkit-transform: rotate(360deg); } }
    @keyframes rotate { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

    .im_fechar {
        width: 25px;
        height: 25px;
        margin-left: 68px;
        margin-top: 5px;
        position: absolute;
        background: lightgray;
        border-radius: 50%;
    }

    .di_form_item, .di_form_item_s, .di_form_item2, .di_form_item2_b {
        display: flex;
        flex-direction: column;
        background: white;
        border-radius:10px;
        margin-right: 0.5%;
        margin-left: 0.5%;
        margin-bottom: 2%;

        padding-right: 2%;
        padding-left: 5%;
        padding-bottom: 2%;
        padding-top: 2%;

        border-color: darkgray;
        border-width: 1px;
        border-style: solid;
        text-align: left;
        /*border-radius: 10px;*/
    }

    .di_form_item_s {
        /*background-image: linear-gradient(var(--bg-blue-grad1), var(--bg-blue-grad2));*/
        margin-bottom: 1%;
        margin-left: 0;
        padding-left: 0;
        border: none;
        font-weight: bold;
        display: flex;
        flex-direction: row;
    }

    .di_form_item2, .di_form_item2_b {
        align-items: center;
        flex-direction: row;
        background-color: white;
        width: 100%;
        /*border-bottom: none;*/
        border-right: none;
        border-top: none;
        border-radius: 0;

        margin-right: 0;
        margin-left: 0;
        margin-bottom: 0;

        padding-right: 0;
        padding-left: 1vw;
        padding-bottom: 0;
    }
    .di_form_item2_b {
        background-color: var(--bg-blue);
    }

    .di_form_item_c {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;

        border-color: darkgray;
        border-width: 1px;
        border-style: solid;
        /*border-top: none;*/
        /*border-left: none;*/
        border-radius: 10px;
        overflow: hidden;
    }
    .di_form_item_c2 {
        display: flex;
        flex-wrap: wrap;
        flex-grow: 1;
        flex-basis: 40%;

        /*background-color: red;*/
    }

    .tx_form, .tx_form_grayb {
        white-space: nowrap;
        color: #383637;
        /*background: blueviolet;*/
    }

    .tx_form, .tx_form_gray, .tx_form_grayb {
        white-space: nowrap;
        color: #383637;
        /*background: blueviolet;*/
    }

    .tx_form, .tx_form_gray, .tx_form_white {
        font-size: 15pt;
        color: var(--bg-blue);
    }

    .tx_form_grayb {
        color: #888;
        font-size: 18pt;
    }

    .tx_inserir {
        color: #888;
        font-size: 12px;
        /*background: red;*/
    }

    .input_name_m2 {
        /*background-image: url('/static/imgs/bg_search01.png');*/
        background-color: transparent;
        background-repeat: no-repeat;
        /*background-size: contain;*/
        background-size: 100% 28px;
        border: none;
        outline: none;
        border-bottom: 2px solid #0c63af;
        /*position: center;*/
        position: relative;
        width: 100%;
        height: 28px;
        height: 4vh;
    }

    .input_name_m2 {
        border: none;
        border-bottom: unset;
        /*font-size: 15pt;*/
        font-size: 3.2vh;
    }

    .input_name_m2:disabled {
        color: #6c757d;
    }

    .tx_form_whiteb, .tx_form_whiteb_sub2 {
        color: var(--bg-blue-circle);
        font-size: 18pt;
        font-size: 1.7vw;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .dv_title_desk {
        background-color: white;
        width: 100%;
        height: 6vh;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 5vh;
    }

    .tx_title_desk {
        font-size: 4vh;
        display: flex;
        align-items: center;
        justify-content: center;
        /*margin-left: 28vw;*/
        /*margin-right: 5vh;*/
    }

    .tx_form_whiteb_sub2 {
        color: darkgray;

        margin-left: 1vw;
        /*background-color: red;*/
        display: flex;
        align-items: center;
    }

    .tx_form_whiteb_sub2 {
        font-size: 2vh;
        margin-right: 1vh;
    }

    .tx_form_grayb {
        color: #888;
        font-size: 18pt;

    }

    .tx_form_white {
        color: white;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .dv_coluna_container {
        width: 95%;
        margin-top: 3vh;
        /*background-color: red;*/
        display: flex;
        justify-content: space-between;
        border-style: solid;
        border-width: 1px;
        border-radius: 10px;
        border-color: darkgray;
    }

    .dv_coluna_edit_register {
        width: 50%;
        padding: 2vw;
    }

    @media screen and (max-width: 999px) {
        .dv_coluna_container {
            flex-direction: column;
            align-items: center;
            width: 100%;
            border-style: none;
        }
        .dv_coluna_edit_register {
            width: 100%;
        }
        .dv_title_desk {
            flex-direction: column;
        }
        .tx_title_desk {
            font-size: 3.5vh;
            margin-left: unset;
            margin-right: unset;
        }
        .tx_form_whiteb {
            font-size: 3.2vh;
        }
    }
    @media screen and (min-width: 1000px) {
    }
    @media screen and (min-width: 1400px) {
    }
    @media screen and (min-width: 1600px) {

    }
    @media screen and (min-width: 1900px) {

    }
    @media screen and (min-width: 2200px) {

    }
</style>



// WEBPACK FOOTER //
// src/components/RegisterAnuncio.vue